// @flow

import { initPhoneMaskModule } from 'common/phone-mask'

import { submitFormOlymp } from './actions/form'

export default () => {
  initPhoneMaskModule()
  document.querySelector('[data-name="enroll-olymp"]')?.addEventListener('submit', submitFormOlymp)
}
